import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { project } from 'components/Wizards/schemas/shared/project'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { language } from 'components/Wizards/schemas/shared/language'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { StepSchema, MultiStepSchema } from 'components/Wizards/schemas/Types'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { number, object } from 'yup'
import { meta } from '../schemaCommon'
import { ChannelType } from 'components/CampaignCreationModal/Types'

export const PictureSchema = object({
  initial_media_file_id: number().default(undefined).transform(safify),
}).meta({
  title: 'Upload a picture of your product',
  supportedMediaTypes: ['image'],
}) as StepSchema

export const getPostDetailsSchema = ({ generationType }: { generationType: string }) =>
  object({
    topic: topic
      .meta({
        label: `What is it about?`,
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType }),
    filename,
    project,
    language: language.meta({ overflow: true }),
    include_emojis: includeEmojis.meta({ overflow: true }),
  }).meta({
    title: 'Did we get the details right?',
  }) as StepSchema

export const FlowESchema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [PictureSchema, getPostDetailsSchema({ generationType })],
  } as MultiStepSchema<ChannelType>)
